var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._g({staticClass:"btn",attrs:{"block":"","depressed":"","color":"#F36F2E","x-large":"","disabled":_vm.disabled,"loading":_vm.loading}},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }